const user = {
  namespaced: true,
  state: {
    userType: '',
    userInfo: null,
    token: null
  },
  mutations: {
    setUser: (state, user) => {
      state.userInfo = user;
      state.userType = user.type;
      state.token = user.token;
      localStorage.setItem('token', user.token);
    },
    logout: state => {
      state.userInfo = null;
      state.userType = '';
      localStorage.removeItem('user');
    }
  }
}

export default user
